import { useTranslation } from "react-i18next"
import cc from "classnames"

import "./Loader.scss"

interface LoaderProps {
  version?: "SMALL" | "LARGE" | "BUTTON"
}

const Loader = (props: LoaderProps): JSX.Element => {
  const { t } = useTranslation<string>()

  return (
    <div className={cc(props.version === "LARGE" ? "loader loader-large" : props.version === "BUTTON" ? "loader-button" : "loader loader-small" )}>
      {t("common:common.loading")}
    </div>
  )
}

export default Loader
